import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_CONTENT_URL,

  responseType: "json",
});

api.interceptors.request.use(
  async (config) => {
    // Check if the custom `requiresAuth` config option is true
    // console.log(config)
   
    if (config.requiresAuth) {

      const session = await fetchAuthSession();

      const idToken = session.tokens.idToken;
      const authToken = session.tokens.accessToken;
      console.log(authToken)

      

      const token = authToken.toString();

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;